// extracted by mini-css-extract-plugin
export default {"page":"RegistrationPage_page__i-Ysq","header":"RegistrationPage_header__Io4-0","subtitle":"RegistrationPage_subtitle__zObxD"};